import { Signal, computed, inject } from '@angular/core';
import { Store } from '@ngrx/store';

import { Label } from '@core/models/labels.model';
import {
  selectLabels,
  selectTags
} from '@core/store/admin/tags-labels/tags-labels.selectors';

export interface PathFilterRegistries {
  tags: Signal<readonly string[]>;
  labels: Signal<readonly Label[]>;
}

/** The current dataspace's registered tags and labels, which tag and label slots pick from. */
export function injectPathFilterRegistries(): PathFilterRegistries {
  const store = inject(Store);
  const tags = store.selectSignal(selectTags);
  return {
    tags: computed(() => tags().map((tag) => tag.label)),
    labels: store.selectSignal(selectLabels)
  };
}
